<div class="h-full min-h-0" *transloco="let t">
  <app-form-preview-split class="h-full" [badgeLabelKey]="'dsp-create-audiences-page.audiences_preview'">
    <div splitMain class="h-full min-h-0 overflow-auto px-8 py-8">
      <div class="flex flex-col gap-6">
        <div class="flex flex-col gap-1">
          <h4>{{ t("dsp-create-audiences-page.set_your_rules") }}</h4>
          <p class="type-body text-muted-foreground m-0">
            {{ t("dsp-create-audiences-page.choose_audience_types_and_lookback") }}
          </p>
        </div>
        <div class="flex flex-col items-start gap-6">
          @for (audienceType of availableAudienceTypes; track audienceType) {
            <div class="w-160">
              <app-dsp-audience-lookback-config
                [audienceType]="audienceType"
                [selectedLookbacks]="rules().audienceConfigs().value()[audienceType]"
                (selectedLookbacksChange)="changeLookback(audienceType, $event)"
              />
            </div>
          }
        </div>
      </div>
    </div>

    <div splitPreview class="h-full min-h-0 overflow-auto p-5">
      <div class="bg-muted flex w-full flex-col rounded-lg border px-3 py-2">
        <div class="type-body-medium text-foreground mb-4">
          {{ t("dsp-create-audiences-page.following_audiences_will_be_created") }}
        </div>
        @for (audience of preview().audiences; track audience) {
          @let name = preview().baseName;
          <div
            class="type-body text-foreground mb-4 truncate overflow-hidden rounded-lg border bg-white p-2 shadow-xs"
            [iTooltip]="name"
          >
            {{ name }} - {{ t("dsp-audiences-type." + audience.audienceType) }} - {{ audience.lookback }}d
          </div>
        } @empty {
          <div class="type-body text-muted-foreground">
            {{ t("dsp-create-audiences-page.create_at_least_one_audience") }}
          </div>
        }
      </div>
    </div>
  </app-form-preview-split>
</div>
